import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { Navigate } from "react-router-dom";

const aeoEnabledPermission = ({
  team,
}: {
  team: { settings: { aeo?: { enabled?: boolean } } };
}) => {
  return team.settings.aeo?.enabled === true;
};

export const aeoRoutes: PermissionedRouteObject[] = [
  {
    path: "",
    handle: { breadcrumb: "AEO", permission: aeoEnabledPermission },
    async lazy() {
      const { Page } = await import("../../page");
      return {
        element: (
          <Page
            hidePadding={(url: string) =>
              ["prompts", "sources"].some((path) => url.includes(path))
            }
          />
        ),
      };
    },
    children: [
      { index: true, element: <Navigate replace to="dashboard" /> },
      {
        path: "dashboard",
        handle: { breadcrumb: "Dashboard" },
        async lazy() {
          const { AeoDashboard } = await import("../../../aeo/dashboard");
          return { Component: AeoDashboard };
        },
      },
      {
        path: "prompts",
        handle: { breadcrumb: "Prompts" },
        children: [
          {
            index: true,
            async lazy() {
              const { AeoPromptsPage } = await import("../../../aeo/prompts");
              return { Component: AeoPromptsPage };
            },
          },
          {
            path: ":promptId",
            handle: { breadcrumb: "Prompt Details" },
            async lazy() {
              const { PromptDetailLayout } = await import(
                "../../../aeo/prompts/prompt-detail-layout"
              );
              return { Component: PromptDetailLayout };
            },
            children: [
              {
                index: true,
                async lazy() {
                  const { AeoPromptDetailPage } = await import(
                    "../../../aeo/prompts/prompt-detail-page"
                  );
                  return { Component: AeoPromptDetailPage };
                },
              },
            ],
          },
        ],
      },
      {
        path: "sources",
        handle: { breadcrumb: "Sources" },
        async lazy() {
          const { AeoSourcesPage } = await import("../../../aeo/sources");
          return { Component: AeoSourcesPage };
        },
      },
      {
        path: "configure",
        handle: { breadcrumb: "Configure" },
        async lazy() {
          const { AeoConfigureLayout } = await import(
            "../../../aeo/configure/configure-layout"
          );
          return { Component: AeoConfigureLayout };
        },
        children: [
          { index: true, element: <Navigate replace to="overview" /> },
          {
            path: "overview",
            async lazy() {
              const { AeoConfigureOverviewPage } = await import(
                "../../../aeo/configure/overview-page"
              );
              return { Component: AeoConfigureOverviewPage };
            },
          },
          {
            path: "competition",
            async lazy() {
              const { AeoConfigureCompetitionPage } = await import(
                "../../../aeo/configure/competition-page"
              );
              return { Component: AeoConfigureCompetitionPage };
            },
          },
          {
            path: "integrations",
            async lazy() {
              const { AeoConfigureIntegrationsPage } = await import(
                "../../../aeo/configure/integrations-page"
              );
              return { Component: AeoConfigureIntegrationsPage };
            },
          },
        ],
      },
    ],
  },
];
